import { useAddLinkModal } from "@circle-react/components/Modals/AddLinkModal";
import { Icon } from "@circle-react/components/shared/Icon";
import { Dropdown } from "@circle-react/components/shared/uikit/Dropdown";
import { useAnyHoverMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import classNames from "classnames";

import { t } from "@/i18n-js/instance";

import { DeleteLinkConfirmation } from "./DeleteLinkConfirmation";
import { LinkItemContent } from "./LinkItemContent";

interface LinkItemProps {
  isAdmin?: boolean;
  link: any;
}

export const LinkItem = ({ link, isAdmin }: LinkItemProps) => {
  const [shouldShowDeleteConfirmation, toggleDeleteConfirmation] =
    useBoolean(false);
  const [isDropdownClosed, toggleIsDropdownClosed] = useBoolean(false);
  const canHover = useAnyHoverMediaQuery();
  const addLinkModal = useAddLinkModal();

  return (
    <>
      <LinkItemContent link={link}>
        {isAdmin && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- Used for stopping propagation of event
          <div
            className={classNames("flex gap-0.5", {
              "hidden group-hover:flex": canHover && isDropdownClosed,
            })}
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
            }}
          >
            <Dropdown
              buttonClassName="flex py-0.5 w-5 h-5 rounded hover:bg-black/10 transition-colors"
              button={<Icon type="16-menu-dots-horizontal" size={16} />}
              buttonLabel={t("community_sidebar.view_sidebar_link_options")}
              onToggle={toggleIsDropdownClosed}
              appendTo={document.body}
            >
              <Dropdown.ItemWithLink
                onClick={() => {
                  void addLinkModal.show({ isEdit: true, link });
                }}
              >
                {t("edit")}
              </Dropdown.ItemWithLink>
              <Dropdown.ItemWithLink onClick={toggleDeleteConfirmation}>
                {t("delete")}
              </Dropdown.ItemWithLink>
            </Dropdown>
          </div>
        )}
      </LinkItemContent>
      <DeleteLinkConfirmation
        link={link}
        isOpen={shouldShowDeleteConfirmation}
        onClose={toggleDeleteConfirmation}
      />
    </>
  );
};
